import './scss/main-riviera.scss';
import './js/index-riviera.js';

// Fonts
import './fonts/silktype-extralight.woff';
import './fonts/silktype-extralight.woff2';
import './fonts/silktype-extralightitalic.woff';
import './fonts/silktype-extralightitalic.woff2';

import './fonts/neuehaasgrotesktextpro.woff';
import './fonts/neuehaasgrotesktextpro.woff2';

// Images
import './images/availability-widget-bg.png';
import './images/riviera-logo-black.svg';
import './images/riviera-logo.svg';
import './images/riviera-wide-logo.png';
import './images/riviera-logo-wide.svg';
import './images/asterisk.svg';
import './images/hotel-panorama.jpg';
import './images/bookingblockold.png';
import './images/bookingblock.png';
import './images/bookingblock@2x.png';
import './images/bookingblock_2x.png';
import './images/transparent.png';
import './images/explore-arrow.svg';
import './images/placeholders/landscape-placeholder1.jpg';
import './images/placeholders/landscape-placeholder2.jpg';
import './images/placeholders/square-placeholder1.jpg';
import './images/placeholders/square-placeholder2.jpg';
import './images/placeholders/floor-plan-placeholder.jpg';
import './images/placeholders/card.jpg';

import './images/header/book.svg';
import './images/header/close.svg';
import './images/header/hamburger.svg';
import './images/header/placeholder-megamenu.png';

import './images/icons/facebook.svg';
import './images/icons/twitter.svg';
import './images/icons/instagram.svg';
import './images/icons/phone.svg';
import './images/icons/phone2.svg';
import './images/icons/grid.svg';
import './images/icons/mail.svg';
import './images/icons/map-pin.svg';
import './images/arrow-left.svg';
import './images/arrow-right.svg';
import './images/gallery-mask.svg';